module.exports = "//static.hsappstatic.net/ContentComponents/static-2.70275/img/DeepL-logo.png"